import { EditPenIcon, InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { FieldInputType } from 'constants/fields';
import { ItemGroupAlignment } from 'constants/ui';
import { getConditionalArray } from 'utils/data';

export const generalViewConfigFields = {
  earliestClosingDate: {
    label: 'Earliest Closing Date',
    name: 'earliestClosingDate',
    contentLabelClassName: 'w-full truncate',
    type: FieldInputType.TEXT,
  },
  manuallyUnderwritten: {
    label: 'Manually Underwritten',
    name: 'manuallyUnderwritten',
    contentLabelClassName: 'w-full truncate',
    type: FieldInputType.TEXT,
  },
};

export const getExpirationDatesViewConfig = ({ onEdit, isEditAllowed, isLoading, isEcdHidden }) => {
  return {
    name: 'General',
    icon: InfoIcon,
    methods: {
      edit: {
        name: 'Edit',
        icon: EditPenIcon,
        onClick: isEditAllowed ? onEdit : undefined,
        disabled: isLoading,
      },
    },
    content: [
      {
        groupsAlignment: ItemGroupAlignment.VERTICAL,
        groups: [
          [
            ...getConditionalArray(!isEcdHidden, [generalViewConfigFields.earliestClosingDate]),
            generalViewConfigFields.manuallyUnderwritten,
          ],
        ],
      },
    ],
  };
};
